// VAD (Voice Activity Detection) Algorithm Constants

// Local algorithm constants (fall back if your constants are missing)
export const WINDOW_SIZE = 5;
export const SLIDING_VOICE_THRESHOLD = 0.5; // avg threshold for sliding window (you can tune)
export const MIN_SPEAK_DURATION_MS = 1000; // 1s to count an incident
export const MAX_CLIP_DURATION_MS = 15000; // 15s per clip
export const SESSION_RECORDING_CAP_MS = 150000; // 150 seconds total recording limit
export const MIN_AUDIO_DURATION_MS = 1000; // 1s minimum duration to upload
export const MAX_CHUNK_DURATION_MS = 10000; // 10s maximum chunk duration

// Recording flow configuration
export const USE_ONSPEECHEND_RECORDING = true; // Set to true to use onSpeechEnd, false for handleFrame

// localStorage keys
export const VAD_INCIDENT_COUNT_LOCALSTORAGE_KEY = 'VAD_INCIDENT_COUNT';
export const VAD_SESSION_CAP_REMAINING_LOCALSTORAGE_KEY =
  'VAD_SESSION_CAP_REMAINING';
